import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { Provider } from 'react-redux'
import reportWebVitals from './reportWebVitals'
import configureStore from './store'
import { ConnectedRouter } from 'connected-react-router'
import ErrorHandler from './../src/services/ErrorHandler'
import history from './utils/history'
import '../src/styles/main.scss'

const initialState = {}
const store = configureStore(initialState, history)

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <Provider store={store}>
    <ErrorHandler>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </ErrorHandler>
  </Provider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
